module.exports = __webpack_public_path__ + "static/img/containers.cfeb2a7.svg";